import { CardAgeEntityProps } from '@entities/card-age/ui/card-age.types';
import cn from 'clsx';
import Image from 'next/image';

import { Illustration, Typography } from '@/shared/ui';

import Bird from '../../../../public/assets/items/bird.webp';
import Monkey from '../../../../public/assets/items/monkey.webp';
import styles from './card-age.module.scss';

export const CardAgeEntity = ({
  title,
  subtitle,
  variant,
  onClick,
}: CardAgeEntityProps) => {
  return (
    <div onClick={onClick} className={styles['container']}>
      <div className={cn(styles['icon'], styles[`icon--${variant}`])}>
        <Typography
          className={cn(styles['icon-text'], styles[`icon-text--${variant}`])}>
          {variant === 'success' ? '< 13' : '13+'}
        </Typography>
      </div>
      <div className={styles['text-block']}>
        <Typography className={styles['title']}>{title}</Typography>
        <Typography className={styles['subtitle']}>{subtitle}</Typography>
      </div>
      <div
        className={cn(
          styles['background'],
          cn(styles[`background--${variant}`]),
        )}>
        <Image
          style={{ zIndex: 1 }}
          fill={true}
          quality={75}
          priority={true}
          loading="eager"
          src={variant === 'success' ? Bird : Monkey}
          alt={'bird'}
        />

        <Illustration
          spanTagClassName={cn(styles['circle'], styles[`circle--${variant}`])}
          spriteName={'backgrounds'}
          name={'illustration-content-age'}
        />
      </div>
    </div>
  );
};
